module.exports = {
    "collapse": `Colapsar`,
    "expand": `Expandir`
};


//# sourceMappingURL=pt-PT.main.js.map
